import { render, staticRenderFns } from "./CoursesApplicationList.vue?vue&type=template&id=0cafd2c1"
import script from "./CoursesApplicationList.vue?vue&type=script&lang=js"
export * from "./CoursesApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports